module.exports = __webpack_public_path__ + "media/images/emblems/Andermatt-coat_of_arms-2733da04edfa2b8877068b6177866ba5.svg";